<div class="p-inputgroup crm-datepicker-inputgroup">
  <span class="p-inputgroup-addon"><i [class]="timeOnly ? 'pi pi-clock' : 'pi pi-calendar'"></i></span>
  <p-calendar
    #calendar
    (ngModelChange)="onModelChange($event)"
    [(ngModel)]="_value"
    [disabled]="disabled"
    [class]="'w-full ' + class"
    [dateFormat]="dateFormat || (view === 'month' ? 'MM yy' : view === 'year' ? 'yy' : 'dd.mm.yy')"
    [defaultDate]="defaultDate"
    [firstDayOfWeek]="1"
    [inputStyleClass]="inputStyleClass"
    [panelStyleClass]="mergedPanelStyleClass"
    [maxDate]="_maxDate"
    [minDate]="_minDate"
    [ngModelOptions]="modelOptions"
    [placeholder]="placeholder"
    [timeOnly]="timeOnly"
    [showButtonBar]="showButtonBar"
    [styleClass]="styleClass"
    [showTime]="showTime"
    [view]="view"
    [appendTo]="appendTo || 'body'"
    [selectionMode]="selectionMode"
    [showClear]="showClear"
    [stepHour]="stepHour"
    [stepMinute]="stepMinute"
    [stepSecond]="stepSecond"
    [autofocus]="autofocus">
  </p-calendar>
</div>
